import { createAsyncThunk } from '@reduxjs/toolkit';
import { projectDetailsActions } from './projectDetailsReducer';

// todo: need to update these, for now added some sample
const actionsConfig = {
  fetchProjectProspects: {
    method: 'get',
    endpoint: '/projects',
    thunkName: 'fetchProjectProspects',
    reducerName: 'currentProjectProspects',
  },
  fetchProjectById: {
    thunkName: 'fetchProjectById',
    method: 'get',
    endpoint: 'projects',
    reducerName: 'currentProject',
    responseKey: 'data',
  },
  addProspectsToProject: {
    thunkName: 'addProspectsToProject',
    method: 'post',
    endpoint: 'projects',
    reducerName: 'addAction',
  },
  addProspectsToFlow: {
    thunkName: 'addProspectsToFlow',
    method: 'post',
    endpoint: 'outreaches',
  },
  removeProspectsFromProject: {
    thunkName: 'removeProspectsFromProject',
    method: 'post',
    endpoint: 'projects',
    reducerName: 'removeAction',
  },
  createReview: {
    thunkName: 'createReview',
    method: 'post',
    endpoint: 'projects',
    reducerName: 'createReview',
  },
  fetchProjectStats: {
    method: 'get',
    endpoint: '/projects',
    thunkName: 'fetchProjectStats',
    reducerName: 'projectStats',
    responseKey: 'data',
  },
  fetchProjectWithLimitedData: {
    method: 'get',
    endpoint: '/projects/list',
    thunkName: 'fetchProjectWithLimitedData',
    reducerName: 'projectLimitedData',
    responseKey: 'data',
  },
};

const apiAction = async (currentAction, config, args) => {
  // eslint-disable-next-line no-unused-vars
  const [dispatch, getState, extraArgument] = args;
  const { http } = extraArgument;
  const { endpoint, method, reducerName: key, responseKey } = currentAction;
  const { requestConfig = {}, isBackground = false } = config;
  const { setLoadingState, fetchSuccess, fetchFailure } = projectDetailsActions;

  // If isBackground skip setting loading state to avoid showing loadders
  if (!isBackground) {
    dispatch(setLoadingState({ key, isLoading: true }));
  }
  try {
    const result = await http[method](endpoint, { ...requestConfig });
    const response = responseKey ? result[responseKey] : result;
    dispatch(fetchSuccess({ key, data: response, status: result?.status }));
    return response;
  } catch (error) {
    dispatch(fetchFailure({ key, error: error.message }));
    console.error(`Error fetching data from ${endpoint}:`, error);
    throw new Error(`Failed to fetch data from ${endpoint}`);
  }
};

export const projectDetailsApiActions = (actionId, config = {}) => {
  // note: to use params, pass it directly inside requestConfig like below
  // requestConfig: { params: queryParams }
  const currentAction = actionsConfig[actionId];
  const { urlPaths, isApi } = config;
  if (!currentAction)
    return console.error('no actions config found for project details');

  let { endpoint, thunkName } = currentAction;

  if (urlPaths) {
    Object.values(urlPaths).forEach((paramValue) => {
      endpoint += `/${paramValue}`;
    });
  }

  if (isApi) {
    return (...args) => {
      return apiAction({ ...currentAction, endpoint }, config, args);
    };
  }

  return (...args) => {
    return createAsyncThunk(
      thunkName,
      apiAction({ ...currentAction, endpoint }, config, args)
    );
  };
};
